import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/useAuth'
import { Loader2 } from 'lucide-react'

export default function LoginSuccess() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const { loading } = useAuth()

    useEffect(() => {
        // AuthContext's AuthCallbackHandler extracts and processes the token.
        // Once loading is done and token is processed, redirect.
        const token = searchParams.get('token')
        if (!token) {
            navigate('/login', { replace: true })
            return
        }
        if (!loading) {
            // Token was processed by AuthCallbackHandler, redirect to app
            navigate('/app', { replace: true })
        }
    }, [loading, searchParams, navigate])

    return (
        <div style={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 16,
        }}>
            <Loader2 size={32} color="var(--primary-light)" className="spin" />
            <p style={{ color: 'var(--text-2)', fontSize: '0.95rem' }}>Connexion en cours…</p>
        </div>
    )
}
